// extracted by mini-css-extract-plugin
module.exports = {"container":"LabelText_container__N3IwE","label_text_wrapper":"LabelText_label_text_wrapper__b_SS6","label":"LabelText_label__FHP2Z","text":"LabelText_text___2GnY"};